<main class="body" name="top" [ngClass]="{'app-light-theme': !themeService.isDark, 'app-dark-theme': themeService.isDark}">
    <a (click)="onClick($event)" class="button" aria-hidden="true">
        <mat-icon class="arrow">arrow_upward</mat-icon>
    </a>

    <header>
        <h1 id="maincontent" tabindex="-1">{{'Terms.Header' | translate}}</h1>
        <p tabindex="0" [innerHTML]="'Terms.Message' | translate"></p>
    </header>

    <div class="terms" [attr.aria-label]="'Terms.Title' | translate">
		<section aria-labelledby="terms-who-we-are">
			<h2 id="terms-who-we-are" tabindex="0">{{'Terms.WhoWeAre.Header' | translate}}</h2>
			<p tabindex="0" [innerHTML]="'Terms.WhoWeAre.Paragraph' | translate"></p>
		</section>

		<section aria-labelledby="terms-account-login">
			<h2 id="terms-account-login" tabindex="0">{{'Terms.AccountAndLogin.Header' | translate}}</h2>
			<p tabindex="0" [innerHTML]="'Terms.AccountAndLogin.Paragraph' | translate"></p>
		</section>

		<section aria-labelledby="terms-acceptable-use">
			<h2 id="terms-acceptable-use" tabindex="0">{{'Terms.AcceptableUse.Header' | translate}}</h2>
			<p tabindex="0" class="no-margin-bottom" [innerHTML]="'Terms.AcceptableUse.Paragraph' | translate"></p>
			<div tabindex="0" class="indent">
				<ul>
					<li [innerHTML]="'Terms.AcceptableUse.Point1' | translate"></li>
					<li [innerHTML]="'Terms.AcceptableUse.Point2' | translate"></li>
					<li [innerHTML]="'Terms.AcceptableUse.Point3' | translate"></li>
					<li [innerHTML]="'Terms.AcceptableUse.Point4' | translate"></li>
					<li [innerHTML]="'Terms.AcceptableUse.Point5' | translate"></li>
					<li [innerHTML]="'Terms.AcceptableUse.Point6' | translate"></li>
					<li [innerHTML]="'Terms.AcceptableUse.Point7' | translate"></li>
					<li [innerHTML]="'Terms.AcceptableUse.Point8' | translate"></li>
					<li [innerHTML]="'Terms.AcceptableUse.Point9' | translate"></li>
				</ul>
			</div>
		</section>

		<section aria-labelledby="terms-online-services">
			<h2 id="terms-online-services" tabindex="0">{{'Terms.OnlineServices.Header' | translate}}</h2>
			<p tabindex="0" [innerHTML]="'Terms.OnlineServices.Paragraph' | translate"></p>
		</section>

		<section aria-labelledby="terms-copyright">
			<h2 id="terms-copyright" tabindex="0">{{'Terms.Copyright.Header' | translate}}</h2>
			<p tabindex="0" [innerHTML]="'Terms.Copyright.Paragraph' | translate"></p>
		</section>

		<section aria-labelledby="terms-trademark">
			<h2 id="terms-trademark" tabindex="0">{{'Terms.Trademark.Header' | translate}}</h2>
			<p tabindex="0" [innerHTML]="'Terms.Trademark.Paragraph' | translate"></p>
		</section>

		<section aria-labelledby="terms-exemptions">
			<h2 id="terms-exemptions" tabindex="0">{{'Terms.Exemptions.Header' | translate}}</h2>
			<p tabindex="0" class="no-margin-bottom" [innerHTML]="'Terms.Exemptions.Paragraph' | translate"></p>
			<div tabindex="0" class="indent">
				<ul>
					<li [innerHTML]="'Terms.Exemptions.a' | translate"></li>
					<li [innerHTML]="'Terms.Exemptions.b' | translate"></li>
					<li [innerHTML]="'Terms.Exemptions.c' | translate"></li>
					<li [innerHTML]="'Terms.Exemptions.d' | translate"></li>
					<li [innerHTML]="'Terms.Exemptions.e' | translate"></li>
				</ul>
			</div>
		</section>

		<section aria-labelledby="terms-non-endorsement">
			<h2 id="terms-non-endorsement" tabindex="0">{{'Terms.NonEndorsement.Header' | translate}}</h2>
			<p tabindex="0" [innerHTML]="'Terms.NonEndorsement.Paragraph' | translate"></p>
		</section>

		<section aria-labelledby="terms-links-other-websites">
			<h2 id="terms-links-other-websites" tabindex="0">{{'Terms.LinksToOtherWebsites.Header' | translate}}</h2>
			<p tabindex="0" [innerHTML]="'Terms.LinksToOtherWebsites.Paragraph' | translate"></p>
		</section>

        <section aria-labelledby="terms-licence">
            <h2 id="terms-licence" tabindex="0">{{'Terms.Licence.Header' | translate}}</h2>
			<section aria-labelledby="terms-licence-limited-use">
				<h3 id="terms-licence-limited-use" tabindex="0">{{'Terms.Licence.Point1.Header' | translate}}</h3>
				<p tabindex="0" [innerHTML]="'Terms.Licence.Point1.Paragraph' | translate"></p>
			</section>
			<section aria-labelledby="terms-licence-termination">
				<h3 id="terms-licence-termination" tabindex="0">{{'Terms.Licence.Point2.Header' | translate}}</h3>
    			<p tabindex="0" [innerHTML]="'Terms.Licence.Point2.Paragraph' | translate"></p>
			</section>		
			<section aria-labelledby="terms-licence-information">
				<h3 id="terms-licence-information" tabindex="0">{{'Terms.Licence.Point3.Header' | translate}}</h3>
				<p tabindex="0" class="no-margin-bottom" [innerHTML]="'Terms.Licence.Point3.Paragraph' | translate"></p>
				<div tabindex="0" class="indent">
					<ul>
						<li [innerHTML]="'Terms.Licence.Point3.a' | translate"></li>
						<li [innerHTML]="'Terms.Licence.Point3.b' | translate"></li>
						<li [innerHTML]="'Terms.Licence.Point3.c' | translate"></li>
						<li [innerHTML]="'Terms.Licence.Point3.d' | translate"></li>
						<li [innerHTML]="'Terms.Licence.Point3.e' | translate"></li>
					</ul>
				</div>
				<p tabindex="0" [innerHTML]="'Terms.Licence.Point3.Conclusion' | translate"></p>
			</section>
        </section>

        <section aria-labelledby="terms-ownership">
            <h2 id="terms-ownership" tabindex="0">{{'Terms.Ownership.Header' | translate}}</h2>
            <p tabindex="0" [innerHTML]="'Terms.Ownership.Paragraph' | translate"></p>
        </section>

		<section aria-labelledby="terms-no-warranty">
			<h2 id="terms-no-warranty" tabindex="0">{{'Terms.NoWarranty.Header' | translate}}</h2>
			<p tabindex="0" [innerHTML]="'Terms.NoWarranty.Paragraph' | translate"></p>
		</section>

        <section aria-labelledby="terms-liability">
            <h2 id="terms-liability" tabindex="0">{{'Terms.Liability.Header' | translate}}</h2>
            <p tabindex="0" [innerHTML]="'Terms.Liability.Paragraph' | translate"></p>
        </section>

        <section aria-labelledby="terms-law">
            <h2 id="terms-law" tabindex="0">{{'Terms.Law.Header' | translate}}</h2>
            <p tabindex="0" [innerHTML]="'Terms.Law.Paragraph' | translate"></p>
        </section>

        <section aria-labelledby="terms-general">
            <h2 id="terms-general" tabindex="0">{{'Terms.General.Header' | translate}}</h2>
            <p tabindex="0" [innerHTML]="'Terms.General.Paragraph' | translate"></p>
        </section>

		<footer tabindex="0">
			{{'Terms.Dates.Created' | translate}} 02/03/2021<br>
			<!-- {{'Terms.Dates.Updated' | translate}} updated date if any <br> -->
			{{'Terms.Dates.Published' | translate}} 03/03/2021
		</footer>
    </div>
</main>